module.exports = __webpack_public_path__ + "static/media/arrowDownProfile.73e6fbda.svg";